"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const graphql_1 = require("..");
exports.createEmailTemplateVersion = graphql_tag_1.default `
  mutation createEmailTemplateVersion(
    $data: EmailTemplateVersionInput!
  ) {
    createEmailTemplateVersion(
      data: $data
    ) {
      ...emailTemplateVersionDetails
      template {
        id
        stagingVersion {
          ...emailTemplateVersionDetails
        }
        productionVersion {
          ...emailTemplateVersionDetails
        }
      }
    }
  }
  ${graphql_1.emailTemplateVersionDetails}
`;
exports.updateEmailTemplateVersion = graphql_tag_1.default `
  mutation updateEmailTemplateVersion(
    $id: ID!,
    $emailTemplateId: ID!,
    $data: EmailTemplateVersionUpdateInput!
  ) {
    updateEmailTemplateVersion(
      id: $id,
      emailTemplateId: $emailTemplateId,
      data: $data
    ) {
      id
      releaseNotes
      blocks {
        id
      }
    }
  }
`;
exports.deployEmailTemplateVersion = graphql_tag_1.default `
  mutation deployEmailTemplateVersion(
    $data: EmailTemplateVersionDeploymentInput!
  ) {
    deployEmailTemplateVersion(
      data: $data
    ) {
      id
      espResponse
      successful
      template {
        id
        stagingVersion {
          ...emailTemplateVersionDetails
        }
        productionVersion {
          ...emailTemplateVersionDetails
        }
      }
    }
  }
  ${graphql_1.emailTemplateVersionDetails}
`;
//# sourceMappingURL=emailTemplateVersions.js.map